export default __webpack_public_path__ + "static/topic15-eb5a15ceabf6c68ec9080efe8bf88e4a.png";